/* assets/casamara-fp-buy.js: the flavor-pdp buy panel (variants, Format and pack pills with the
   Round 5 states and pack carry-over, One-time / Subscribe and frequency, add to cart, notify).
   Moved out of sections/flavor-pdp.liquid's javascript block on 261001 (round 9, quick
   view): Shopify only runs a section's bundled JavaScript on pages where that section renders,
   so the homepage quick-view modal could not reach it. The code is unchanged; it is loaded by
   sections/flavor-pdp.liquid (PDP) and sections/featured-collection.liquid (quick view). */
/* 261001 round 9 (Jason, quick view): the buy panel is a function of its root, so the same code
   drives the PDP and the quick-view modal (assets/casamara-quickview.js injects a
   ?view=quickview copy of this section and calls window.fpInitBuy on it). The PDP calls it once
   below for its own section. A root is only ever initialised once. */
window.fpInitBuy = function (root) {
  if (!root || root.__fpBuy) return;
  root.__fpBuy = true;
  /* The variant a deep link or a quick-view card asked for: the section's own attribute first
     (set in quick view from the card's ?variant=), then the page URL (PDP deep links). */
  function prefVariant() {
    var a = root.getAttribute('data-fp-variant-pref');
    if (a) return a;
    try { return new URLSearchParams(location.search).get('variant'); } catch (e) { return null; }
  }
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-fp-variants]').textContent); } catch (e) {}
  var nutri = {};
  try { nutri = JSON.parse(root.querySelector('[data-fp-nutrition]').textContent); } catch (e) {}

  var state = { format: null, size: null };
  var soldOut = false; /* 260828 D-1: drives the ATC-as-notify behaviour */
  var fmtBtns = root.querySelectorAll('[data-fp-format]');
  var sizeBtns = root.querySelectorAll('[data-fp-size]');
  if (fmtBtns[0]) state.format = fmtBtns[0].getAttribute('data-fp-format');
  if (sizeBtns[0]) state.size = sizeBtns[0].getAttribute('data-fp-size');
  /* 261001 round 5 (Jason): switching format keeps the pack count. Size values can name the
     format ("24 cans" / "24 bottles"), so packs are matched by count. Same count if that pack
     exists in the target format, else the nearest count, preferring the next size up.
     requireAvail limits the search to available variants (availability flag only). */
  function packCount(sz) { var n = parseInt(String(sz || ''), 10); return isNaN(n) ? 0 : n; }
  function variantIn(fmt, sz) {
    return variants.find(function (x) { var o = x.options || []; return (!fmt || o.indexOf(fmt) !== -1) && o.indexOf(sz) !== -1; });
  }
  function nearestSize(fmt, fromSize, requireAvail) {
    var want = packCount(fromSize), list = [];
    sizeBtns.forEach(function (b) {
      var sz = b.getAttribute('data-fp-size'); var v = variantIn(fmt, sz);
      if (v && (!requireAvail || v.available)) list.push({ size: sz, count: packCount(sz) });
    });
    if (!list.length) return null;
    var exact = list.filter(function (x) { return x.size === fromSize; })[0] || (want > 0 && list.filter(function (x) { return x.count === want; })[0]);
    if (exact) return exact.size;
    var up = list.filter(function (x) { return x.count > want; }).sort(function (a, b) { return a.count - b.count; })[0];
    if (up) return up.size;
    var down = list.filter(function (x) { return x.count < want; }).sort(function (a, b) { return b.count - a.count; })[0];
    return down ? down.size : list[0].size;
  }
  function setSize(sz) {
    if (!sz) return;
    state.size = sz;
    sizeBtns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-fp-size') === sz); });
  }
  /* 261001 round 5: keep One-time vs Subscribe across variant changes when the new variant
     offers a plan. wantSub is the shopper's last choice; fpProg marks our own radio changes. */
  var wantSub = false, fpProg = false;

  /* C13 (260827): honor ?variant= deep links — seed the pills and state from the
     URL-selected variant so format/size cards elsewhere can land here preselected. */
  (function () {
    var vid = prefVariant();
    if (!vid) return;
    var uv = variants.find(function (v) { return String(v.id) === String(vid); });
    if (!uv || !uv.options) return;
    uv.options.forEach(function (o) {
      fmtBtns.forEach(function (b) {
        if (b.getAttribute('data-fp-format') === o) {
          fmtBtns.forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on'); state.format = o;
        }
      });
      sizeBtns.forEach(function (b) {
        if (b.getAttribute('data-fp-size') === o) {
          sizeBtns.forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on'); state.size = o;
        }
      });
    });
  })();

  /* W-15-B3 (260910, Eric): never open on a sold-out format when another format is
     available. Runs only when no ?variant= deep link chose the format, and only on
     merged products (two or more Format pills). Keeps the size if that size is
     available in the other format; otherwise takes the other format's first
     available size. A product sold out in every format is left alone. */
  (function () {
    var hasDeepLink = !!prefVariant();
    if (hasDeepLink || fmtBtns.length < 2) return;
    function availIn(fmt, size) {
      return variants.find(function (v) {
        var o = v.options || [];
        return v.available && o.indexOf(fmt) !== -1 && (!size || o.indexOf(size) !== -1);
      });
    }
    if (availIn(state.format, state.size)) return;
    var pick = null, pickSize = null;
    fmtBtns.forEach(function (b) {
      if (pick) return;
      var f = b.getAttribute('data-fp-format');
      if (f === state.format) return;
      var nsz = nearestSize(f, state.size, true);
      var v = nsz ? variantIn(f, nsz) : null;
      if (v) { pick = f; pickSize = v; }
    });
    if (!pick) return;
    fmtBtns.forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fp-format') === pick); });
    state.format = pick;
    if (pickSize && pickSize.options) {
      sizeBtns.forEach(function (b) {
        var s = b.getAttribute('data-fp-size');
        if (pickSize.options.indexOf(s) !== -1) {
          sizeBtns.forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on'); state.size = s;
        }
      });
    }
  })();

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function perMoney(c) { return '$' + (c / 100).toFixed(2); }
  function match() {
    return variants.find(function (v) {
      var o = v.options || [];
      return (!state.format || o.indexOf(state.format) !== -1) && (!state.size || o.indexOf(state.size) !== -1);
    });
  }
  function isBottle() { return (state.format || '').toLowerCase().indexOf('bottle') !== -1; }
  function unitWord() { return state.format ? (isBottle() ? 'bottle' : 'can') : (root.getAttribute('data-fp-unit') || 'can'); }
  function variantFor(size) {
    return variants.find(function (x) { var o = x.options || []; return (!state.format || o.indexOf(state.format) !== -1) && o.indexOf(size) !== -1; });
  }
  /* W-17: each variant carries its own Loop selling-plan group (ids and cadence counts differ
     per variant), so the cadence row and subscription price rebuild from the variant's real
     allocations on every render — never from selling_plan_groups.first alone. */
  function shortPlanName(n) { return (n || '').replace('Deliver every', 'Every').replace(' weeks', ' wks').replace(' week', ' wk'); }
  var selectedPlanName = null;
  /* C8-polish (260904): the chosen allocation's price, in cents, or null when the variant has
     no plans. The add-to-cart button reads it whenever the Subscribe row is selected, so the
     button price is the figure the shopper will be charged — never the one-time price with
     a saving implied elsewhere. Set by rebuildCadence, read by syncAtcPrice. */
  var subPrice = null;
  var currentVariant = null;
  function syncAtcPrice() {
    var v = currentVariant; if (!v) return;
    var useSub = !!(subRadio && subRadio.checked && subPrice != null);
    var shown = useSub ? subPrice : v.price;
    var pr = root.querySelector('[data-fp-atc-price]'); if (pr) pr.textContent = money(shown);
    var stp = root.querySelector('[data-fp-sticky-price]'); if (stp) stp.textContent = money(shown);
  }
  function rebuildCadence(v) {
    var cadence = root.querySelector('[data-fp-cadence]');
    var plans = (v && v.plans) || [];
    /* Some live variants carry allocations from several stacked Loop groups (18 on one
       Alta variant). Dedupe by cadence name; first occurrence = first group wins. */
    var seen = {};
    plans = plans.filter(function (p2) { var k = shortPlanName(p2.name); if (seen[k]) return false; seen[k] = true; return true; });
    var subRow = subRadio ? subRadio.closest('.fp-drow') : null;
    var sp = root.querySelector('[data-fp-sub-price]');
    var terms = root.querySelector('[data-fp-sub-terms]');
    if (!plans.length) {
      /* 261001 round 5: no plan on this variant, so fall back to One-time (wantSub is kept). */
      var onceR = root.querySelector('[data-fp-once]');
      if (subRadio && subRadio.checked && onceR) { fpProg = true; onceR.checked = true; onceR.dispatchEvent(new Event('change', { bubbles: true })); fpProg = false; }
      if (terms) { terms.textContent = ''; terms.hidden = true; }
      subPrice = null;
      if (cadence) { cadence.innerHTML = ''; cadence.hidden = true; }
      if (subRow) subRow.style.display = 'none';
      if (sp) sp.textContent = '';
      return;
    }
    if (subRow) subRow.style.display = '';
    /* 260924 (Jason): default to every 4 weeks; first offered frequency if a plan has none. */
    var chosen = plans.filter(function (q) { return /every 4 weeks/i.test(q.name || ''); })[0] || plans[0];
    if (selectedPlanName) { plans.forEach(function (p2) { if (shortPlanName(p2.name) === selectedPlanName) chosen = p2; }); }
    selectedPlanName = shortPlanName(chosen.name);
    subPrice = chosen.price;
    if (terms) { /* 260924: bullets, items split on "||" from casamara-sub-terms */
      terms.innerHTML = '';
      (chosen.terms || '').split('||').forEach(function (t) {
        if (!t) return;
        var li = document.createElement('span'); li.className = 'fp-sub-li'; li.setAttribute('role', 'listitem'); li.textContent = t; terms.appendChild(li);
      });
      terms.hidden = !chosen.terms;
    }
    if (subRadio) subRadio.value = chosen.id;
    /* 260902 (Jason, D5): dropdown instead of pills. */
    if (cadence) {
      cadence.innerHTML = '';
      var sel = document.createElement('select');
      sel.className = 'fp-cad-select';
      sel.setAttribute('data-fp-cad-select', '');
      sel.setAttribute('aria-label', 'Delivery frequency');
      plans.forEach(function (p2) {
        var o = document.createElement('option');
        o.value = p2.id;
        o.textContent = p2.name;
        if (p2 === chosen) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        var p2 = null;
        plans.forEach(function (q) { if (String(q.id) === sel.value) p2 = q; });
        if (!p2) return;
        selectedPlanName = shortPlanName(p2.name);
        if (subRadio) { subRadio.value = p2.id; subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); }
        render();
      });
      cadence.appendChild(sel);
      cadence.hidden = !(subRadio && subRadio.checked);
    }
    if (sp) sp.textContent = money(chosen.price);
    /* 261001 round 5: the shopper chose Subscribe earlier and this variant offers it, so restore it.
       The frequency is kept by selectedPlanName above. */
    if (wantSub && subRadio && !subRadio.checked) { fpProg = true; subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); fpProg = false; }
    /* Dynamic label (Jason 260824): percent derives from the variant's real allocation —
       allocation price against the allocation's own compare_at_price (the variant price
       without the plan), which the JSON above carries as "compare". */
    var lbl = root.querySelector('[data-fp-sub-label]');
    var base = chosen.compare || (v && v.price);
    if (lbl && base) {
      var pct = Math.round((1 - chosen.price / base) * 100);
      lbl.textContent = pct > 0 ? 'Subscribe · Save ' + pct + '%' : 'Subscribe';
    }
  }
  /* 260924 (Jason): variety pack flavor list follows the format. Bottles show only the flavors
     whose product has a bottle variant (data-fp-bottle); the count word follows. */
  function applyPackFormat() {
    var tabs = root.querySelectorAll('[data-fp-pack-tab]');
    if (!tabs.length) return;
    var bottles = /bottle/i.test(state.format || '');
    var words = ['zero','one','two','three','four','five','six','seven','eight'];
    var shown = 0, activeHidden = false, firstShown = null;
    tabs.forEach(function (t) {
      var hide = bottles && t.getAttribute('data-fp-bottle') !== 'true';
      t.hidden = hide;
      if (!hide) { shown++; if (!firstShown) firstShown = t; }
      if (hide && t.classList.contains('is-on')) activeHidden = true;
    });
    var w = root.querySelector('[data-fp-pack-word]');
    if (w) w.textContent = words[shown] || String(shown);
    if (activeHidden && firstShown) firstShown.click();
  }
  /* 260924 (Jason): "Extra Dry Variety in Cans" follows the format picker. */
  function applyStyleFormat() {
    var el = root.querySelector('[data-fp-style-format]');
    if (!el || !state.format) return;
    el.textContent = /bottle/i.test(state.format) ? 'Bottles' : 'Cans';
  }
  /* 260929 (Jason): copy follows the Format pill. [data-fp-fmt-copy] = per-format product copy
     (snippets/fp-format-copy); [data-fp-unit-copy] = "can" / "bottle" nutrition in the pack
     ingredients panel; .fp-ing-pack[data-fp-bottle] = a pack flavor, hidden on Bottles when it
     is not made in bottles (same rule as applyPackFormat). */
  function applyFormatCopy() {
    if (!state.format) return;
    var bottles = isBottle();
    root.querySelectorAll('[data-fp-fmt-copy]').forEach(function (el) {
      el.hidden = el.getAttribute('data-fp-fmt-copy') !== state.format;
    });
    var u = unitWord();
    root.querySelectorAll('[data-fp-unit-copy]').forEach(function (el) {
      el.hidden = el.getAttribute('data-fp-unit-copy') !== u;
    });
    root.querySelectorAll('.fp-ing-pack[data-fp-bottle]').forEach(function (el) {
      el.hidden = bottles && el.getAttribute('data-fp-bottle') !== 'true';
    });
  }
  /* 260929 (Jason): sold-out alternative. The selected variant is unavailable; is another
     format of this product available? Prefer the same pack size, else that format's first
     available size. Returns { format, variant } or null. Availability only, never quantities. */
  function altFormat() {
    if (!state.format || fmtBtns.length < 2) return null;
    var best = null;
    fmtBtns.forEach(function (b) {
      if (best) return;
      var f = b.getAttribute('data-fp-format');
      if (f === state.format) return;
      /* 261001 round 5: same pack count if available there, else nearest available (next size up first). */
      var sz = nearestSize(f, state.size, true);
      var any = sz ? variantIn(f, sz) : null;
      if (any) best = { format: f, variant: any };
    });
    return best;
  }
  function fmtWord(f) { return String(f || '').toLowerCase(); }
  function fmtWordCap(f) { var w = fmtWord(f); return w.charAt(0).toUpperCase() + w.slice(1); }
  var altPick = null;
  function applySoldOutAlt(v) {
    var elsewhere = root.querySelector('[data-fp-elsewhere]');
    var alt = root.querySelector('[data-fp-alt]');
    altPick = v.available ? null : altFormat();
    if (alt) {
      if (altPick) {
        var o = alt.querySelector('[data-fp-alt-out]'); if (o) o.textContent = fmtWordCap(state.format);
        var sw = alt.querySelector('[data-fp-alt-switch]'); if (sw) sw.textContent = fmtWord(altPick.format);
        /* 260930 round 3 (Jason): "find something else" points at the other format too. */
        var go = alt.querySelector('[data-fp-alt-go]'); if (go) go.setAttribute('href', location.pathname + '?variant=' + altPick.variant.id);
      }
      alt.hidden = !altPick;
    }
    if (elsewhere) elsewhere.hidden = v.available || !!altPick;
  }
  function doAltSwitch(e) {
    if (!altPick) return;
    if (e && e.preventDefault) e.preventDefault();
    var pick = altPick;
    fmtBtns.forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fp-format') === pick.format); });
    state.format = pick.format;
    var opts = pick.variant.options || [];
    sizeBtns.forEach(function (b) {
      var sz = b.getAttribute('data-fp-size');
      if (opts.indexOf(sz) !== -1) { state.size = sz; }
    });
    sizeBtns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-fp-size') === state.size); });
    render();
    var on = root.querySelector('[data-fp-format].is-on'); if (on) on.focus();
  }
  var altBtn = root.querySelector('[data-fp-alt-switch]');
  if (altBtn) altBtn.addEventListener('click', doAltSwitch);
  var altGo = root.querySelector('[data-fp-alt-go]');
  if (altGo) altGo.addEventListener('click', doAltSwitch);
  function render() {
    var firstAvail = null;
    sizeBtns.forEach(function (btn) {
      var size = btn.getAttribute('data-fp-size');
      var count = parseInt(btn.getAttribute('data-fp-count') || '0', 10);
      var vv = variantFor(size);
      var perEl = btn.querySelector('[data-fp-per]');
      /* 261001 round 5: a pack that exists in this format but is not available is marked out. */
      var packOut = !!(vv && !vv.available);
      btn.classList.toggle('is-out', packOut);
      btn.classList.toggle('is-avail', !!(vv && vv.available));
      var noteEl = btn.querySelector('[data-fp-pack-note]');
      if (noteEl) { noteEl.textContent = packOut ? (root.getAttribute('data-fp-out-word') || 'sold out') : ''; noteEl.hidden = !packOut; }
      if (perEl) perEl.hidden = packOut;
      if (vv) {
        btn.style.display = '';
        if (!firstAvail) firstAvail = size;
        if (perEl && count) perEl.textContent = perMoney(Math.round(vv.price / count)) + '/' + unitWord();
      } else {
        btn.style.display = 'none';
      }
    });
    if (!firstAvail) { sizeBtns.forEach(function (b) { b.style.display = ''; }); }
    var curVisible = false;
    sizeBtns.forEach(function (b) { if (b.getAttribute('data-fp-size') === state.size && b.style.display !== 'none') curVisible = true; });
    if (!curVisible && firstAvail) {
      state.size = firstAvail;
      sizeBtns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-fp-size') === firstAvail); });
    }
    var v = match(); if (!v) return;
    currentVariant = v;
    var id = root.querySelector('[data-fp-variant-id]'); if (id) id.value = v.id;
    var op = root.querySelector('[data-fp-once-price]'); if (op) op.textContent = money(v.price);
    rebuildCadence(v); /* W-17 */
    applyPackFormat(); /* 260924 */
    applyStyleFormat(); /* 260924 */
    applyFormatCopy(); /* 260929 */
    syncAtcPrice();    /* C8-polish: button price follows the Subscribe / One-time choice */
    /* 260828 D-1: sold out turns the ATC button itself into the notify trigger. It stays
       enabled (it must be clickable to open the email row) and the price is suppressed. */
    soldOut = !v.available;
    var atc = root.querySelector('.fp-atc'); var lb = root.querySelector('[data-fp-atc-label]');
    var grid = root.querySelector('[data-fp-atc-grid]');
    if (atc) atc.disabled = false;
    if (lb) lb.textContent = v.available ? 'Add to Cart' : ((grid && grid.getAttribute('data-fp-bis-label')) || 'Sold Out – Notify Me When Available');
    if (grid) grid.classList.toggle('is-bis', soldOut);
    var sep = root.querySelector('.fp-atc-sep'); if (sep) sep.hidden = soldOut;
    var prEl = root.querySelector('[data-fp-atc-price]'); if (prEl) prEl.hidden = soldOut;
    var bis = root.querySelector('[data-fp-bis]');
    if (bis && !soldOut) { bis.hidden = true; }
    /* 260828 R6 (item 2): the substitute band is gone; the one-line link takes its place and
       shows only while the selected variant is sold out. */
    applySoldOutAlt(v); /* 260929: "Cans are out for now, bottles ship today. Or find something else" */
    var stb = root.querySelector('[data-fp-sticky-atc]'); if (stb) stb.disabled = !v.available;
    var hero = root.querySelector('.fp-media-img');
    if (hero && v.image) { hero.removeAttribute('srcset'); hero.src = v.image; }
    var np = root.querySelector('[data-fp-nutri]');
    var key = isBottle() ? 'bottle' : 'can';
    var n = nutri[key] || nutri.can || nutri.bottle;
    /* 260828 R5 (Jason note 5): same wording and same rules as snippets/fp-nutrition.liquid.
       A %DV prints only when the metafield carries it — never computed here. */
    if (np && n) {
      var dv = function (v) { return v ? ' (' + v + ' DV)' : ''; };
      var txt = 'Serv. Size ' + n.serving + '. Amount Per Serving: Calories ' + n.cal +
        ', Total Fat ' + n.fat + dv(n.fat_dv) + ', Sodium ' + n.sodium + dv(n.sodium_dv) +
        ', Total Carb. ' + n.carb + dv(n.carb_dv) + ', Sugars ' + n.sugar +
        ', Protein ' + n.protein + '.';
      if (n.fat_dv || n.sodium_dv || n.carb_dv) { txt += ' Percent Daily Values (DV) are based on a 2,000 calorie diet.'; }
      np.textContent = txt;
    }
    syncSticky();
  }
  fmtBtns.forEach(function (b) { b.addEventListener('click', function () {
    fmtBtns.forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
    var nf = b.getAttribute('data-fp-format');
    setSize(nearestSize(nf, state.size, false)); /* 261001 round 5: keep the pack count */
    state.format = nf; render();
  }); });
  sizeBtns.forEach(function (b) { b.addEventListener('click', function () { sizeBtns.forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on'); state.size = b.getAttribute('data-fp-size'); render(); }); });
  var qty = root.querySelector('[data-fp-qty]');
  var dec = root.querySelector('[data-fp-qty-dec]'); var inc = root.querySelector('[data-fp-qty-inc]');
  if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1); });
  if (inc) inc.addEventListener('click', function () { qty.value = Math.min(99, parseInt(qty.value || '1', 10) + 1); });
  var cadence = root.querySelector('[data-fp-cadence]');
  var subRadio = root.querySelector('[data-fp-sub]');
  root.querySelectorAll('.fp-drow input').forEach(function (r) {
    r.addEventListener('change', function () {
      root.querySelectorAll('.fp-drow').forEach(function (l) { l.classList.remove('is-on'); });
      r.closest('.fp-drow').classList.add('is-on');
      if (cadence) cadence.hidden = !(subRadio && subRadio.checked);
      if (!fpProg) wantSub = !!(subRadio && subRadio.checked); /* 261001 round 5 */
      syncAtcPrice(); /* C8-polish */
    });
  });
  /* W-17: cadence buttons are built per-variant in rebuildCadence(); the Liquid-rendered
     initial buttons are replaced on first render. */
  // Format "i" popover — toggles the can/bottle differentiation block without selecting the format
  var fmtInfo = root.querySelector('[data-fp-fmt-info]');
  root.querySelectorAll('[data-fp-fmt-info-btn]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (fmtInfo) fmtInfo.hidden = !fmtInfo.hidden;
    });
    b.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); if (fmtInfo) fmtInfo.hidden = !fmtInfo.hidden; }
    });
  });
  // 260924: Subscribe row "i" toggles the subscription terms panel without selecting the row
  var subInfo = root.querySelector('[data-fp-sub-info]');
  root.querySelectorAll('[data-fp-sub-info-btn]').forEach(function (b) {
    function toggleSub(e) {
      e.preventDefault(); e.stopPropagation();
      if (!subInfo) return;
      subInfo.hidden = !subInfo.hidden;
      b.setAttribute('aria-expanded', subInfo.hidden ? 'false' : 'true');
    }
    b.addEventListener('click', toggleSub);
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggleSub(e); });
  });
  // W-19: variety-pack aromatics tabs
  var packTabs = root.querySelectorAll('[data-fp-pack-tab]');
  if (packTabs.length) {
    packTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-fp-pack-tab');
        packTabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-fp-pack-panel]').forEach(function (pn) {
          pn.hidden = pn.getAttribute('data-fp-pack-panel') !== i;
        });
      });
    });
  }

  /* 260828 D-4: how-to tiles replace the accordions. One panel open at a time; clicking the
     open tile closes it. Same content, same metafield sources — presentation only.

     260828 R7 (Jason item 4, "the other boxes don't open when i click them"): ONE delegated
     listener on the grid, guarded by a flag on the grid element, instead of one listener per
     tile. Per-tile listeners are additive: anything that runs this block twice on the same DOM
     (a section re-render in the theme editor, a bundle evaluated twice) gives every tile two
     handlers, and two handlers on one click toggle the tile open and straight back shut — which
     presents exactly as "clicking does nothing". The flag makes a second run a no-op and the
     delegation means there is a single handler to run at all. */
  var tilesGrid = root.querySelector('[data-fp-tiles]');
  if (tilesGrid && !tilesGrid.hasAttribute('data-fp-tiles-bound')) {
    tilesGrid.setAttribute('data-fp-tiles-bound', '');
    tilesGrid.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-fp-tile]') : null;
      if (!t || !tilesGrid.contains(t)) return;
      var i = t.getAttribute('data-fp-tile');
      var wasOn = t.classList.contains('is-on');
      root.querySelectorAll('[data-fp-tile]').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-expanded', 'false'); if (x.parentNode) x.parentNode.classList.remove('is-open'); });
      root.querySelectorAll('[data-fp-panel]').forEach(function (pn) { pn.hidden = true; });
      if (!wasOn) {
        t.classList.add('is-on');
        t.setAttribute('aria-expanded', 'true');
        if (t.parentNode) t.parentNode.classList.add('is-open');
        var panel = root.querySelector('[data-fp-panel="' + i + '"]');
        if (panel) panel.hidden = false;
      }
    });
    /* 260910 (Jason, phone tiles): the open tile's <h2> carries .is-open so the phone layout
       can span it full width without :has(). Mirrors the server-rendered first tile. */
    root.querySelectorAll('[data-fp-tile].is-on').forEach(function (x) { if (x.parentNode) x.parentNode.classList.add('is-open'); });
  }

  /* 260828 R2 (Jason): the serve-steps "optional" unfurl is removed. Every step renders
     visible from the start, so there is no nested toggle to wire up here. */
  // Gallery thumbnails
  var heroImg = root.querySelector('.fp-media-img');
  root.querySelectorAll('[data-fp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!heroImg) return;
      heroImg.removeAttribute('srcset');
      heroImg.src = t.getAttribute('data-fp-thumb');
      root.querySelectorAll('[data-fp-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });

  // Cart drawer add (falls back to native submit)
  var form = root.querySelector('.fp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      /* 260828 D-1: when the selected variant is sold out the submit button is the notify
         trigger — never an add-to-cart. Reveal the inline email row instead of posting. */
      if (soldOut) {
        e.preventDefault();
        var bisEl = root.querySelector('[data-fp-bis]');
        if (bisEl) {
          bisEl.hidden = false;
          var inp = bisEl.querySelector('[data-fp-bis-email]');
          if (inp) inp.focus();
        }
        return;
      }
      /* 261001 round 9: in quick view the add never leaves the page. It posts the form to
         /cart/add.js and hands the result to the modal (fp:qv-added), which updates the header
         count; assets/casamara-ship-bar.js already re-reads the cart after any /cart/add. */
      if (root.hasAttribute('data-fp-qv') && window.fetch) {
        e.preventDefault();
        var atcBtn = root.querySelector('.fp-atc'); if (atcBtn) atcBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok && !d.status, data: d }; }); })
          .catch(function () { return { ok: false, data: null }; })
          .then(function (res) {
            if (atcBtn) atcBtn.disabled = false;
            root.dispatchEvent(new CustomEvent('fp:qv-added', { bubbles: true, detail: res }));
          });
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) { form.submit(); return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(d);
        })
        .catch(function () { form.submit(); });
    });
  }

  // Sticky buy bar (mini-configurator on desktop, minimal on mobile)
  function syncSticky() {
    root.querySelectorAll('[data-fp-s-size]').forEach(function (b) {
      var v = b.getAttribute('data-fp-s-size');
      var main = null;
      sizeBtns.forEach(function (m) { if (m.getAttribute('data-fp-size') === v) main = m; });
      b.style.display = main && main.style.display === 'none' ? 'none' : '';
      b.classList.toggle('is-on', v === state.size);
    });
    root.querySelectorAll('[data-fp-s-format]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-fp-s-format') === state.format);
    });
    var subOn = subRadio && subRadio.checked;
    var so = root.querySelector('[data-fp-s-once]');
    var ss = root.querySelector('[data-fp-s-sub]');
    if (so) so.classList.toggle('is-on', !subOn);
    if (ss) ss.classList.toggle('is-on', !!subOn);
  }
  var sticky = root.querySelector('[data-fp-sticky]');
  var buyPanel = root.querySelector('.fp-buy');
  if (sticky && buyPanel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
    }, { threshold: 0 }).observe(buyPanel);
    var stickyBtn = root.querySelector('[data-fp-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
    root.querySelectorAll('[data-fp-s-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-fp-s-size');
        sizeBtns.forEach(function (m) { if (m.getAttribute('data-fp-size') === v) m.click(); });
        syncSticky();
      });
    });
    root.querySelectorAll('[data-fp-s-format]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-fp-s-format');
        fmtBtns.forEach(function (m) { if (m.getAttribute('data-fp-format') === v) m.click(); });
        syncSticky();
      });
    });
    var onceRadio = root.querySelector('[data-fp-once]');
    var sOnce = root.querySelector('[data-fp-s-once]');
    var sSub = root.querySelector('[data-fp-s-sub]');
    if (sOnce) sOnce.addEventListener('click', function () {
      if (onceRadio) { onceRadio.checked = true; onceRadio.dispatchEvent(new Event('change', { bubbles: true })); }
      syncSticky();
    });
    if (sSub) sSub.addEventListener('click', function () {
      if (subRadio) { subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); }
      syncSticky();
    });
    root.querySelectorAll('.fp-drow input').forEach(function (r) {
      r.addEventListener('change', syncSticky);
    });
    syncSticky();
  }

  // Klaviyo back-in-stock
  var bisWrap = root.querySelector('[data-fp-bis]');
  if (bisWrap) {
    var bisBtn = root.querySelector('[data-fp-bis-btn]');
    var bisEmail = root.querySelector('[data-fp-bis-email]');
    var bisMsg = root.querySelector('[data-fp-bis-msg]');
    if (bisBtn) bisBtn.addEventListener('click', function () {
      var email = (bisEmail && bisEmail.value || '').trim();
      var vid = root.querySelector('[data-fp-variant-id]');
      if (!email || email.indexOf('@') === -1 || !vid) { if (bisMsg) { bisMsg.hidden = false; bisMsg.textContent = 'Enter a valid email address.'; } return; }
      var company = bisWrap.getAttribute('data-klaviyo');
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + company, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid.value } } } } })
      }).then(function (r) {
        if (bisMsg) { bisMsg.hidden = false; bisMsg.textContent = r.ok || r.status === 202 ? "You're on the list." : 'Something went wrong. Try again.'; }
      }).catch(function () {
        if (bisMsg) { bisMsg.hidden = false; bisMsg.textContent = 'Something went wrong. Try again.'; }
      });
    });
  }

  render();

  /* 260904 (Jason, Subscribe & Save): honor ?subscribe=1 deep links the way ?variant= is
     honored above — after the first render, so the variant's plans are already built,
     select the Subscribe row and let its change handler reveal the cadence dropdown. */
  (function () {
    var want = null;
    if (root.hasAttribute('data-fp-qv')) return;
    try { want = new URLSearchParams(location.search).get('subscribe'); } catch (e) {}
    if (!want || want === '0') return;
    if (!subRadio || !subRadio.value) return;
    var subRow = subRadio.closest('.fp-drow');
    if (subRow && subRow.style.display === 'none') return;
    subRadio.checked = true;
    subRadio.dispatchEvent(new Event('change', { bubbles: true }));
  })();
};
(function () {
  var pdp = document.querySelector('section.fp:not([data-fp-qv])');
  if (pdp) window.fpInitBuy(pdp);
})();
